import { useTranslate } from '@tolgee/react';
import { formatNumber } from 'utils/numberFormat';
import * as React from 'react';
import { find, maxBy } from 'lodash-es';
import CheckContainer from 'components/CheckContainer';
import useSmartField from 'hooks/useSmartField';
import { OrderAIFormikState } from './type';
import { produce } from 'immer';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';

export const TrafficPkg = React.memo(() => {
  const { t } = useTranslate();
  const { field } =
    useSmartField<OrderAIFormikState['trafficPkgInfoOrigin']>('trafficPkgInfoOrigin');
  const [recommendTrafficPackageInfos, setRecommendTrafficPackageInfos] = React.useState(
    field.value.trafficPackage.recommendTrafficPackageInfos,
  );
  const { helpers: numHelpers } = useSmartField('handleNumTraffic');
  const { helpers: durationNumHelpers } = useSmartField('durationNum');
  const maxPkg = maxBy(recommendTrafficPackageInfos, 'handleNum');
  const lang = useSystemLanguageValue();
  const discount = ['zh-CN'].includes(lang) ? '9' : '10%';

  return (
    <div>
      <h4>
        {t('aiorder_traffic_pkg_quota')}
        <span className="text-[12px] text-[var(--fett-surface-error-text)] leading-[18px] ml-[2px] font-normal">
          {t('aiorder_discount', {
            renci: formatNumber(maxPkg?.handleNum, '0,0[.]00'),
            zhekou: discount,
          })}
        </span>
      </h4>

      <div>
        {recommendTrafficPackageInfos.map((each) => {
          return (
            <CheckContainer
              key={each.handleNum}
              checked={each.isSelected}
              onChange={() => {
                setRecommendTrafficPackageInfos(
                  produce((draft) => {
                    draft.forEach((item) => {
                      if (item.handleNum === each.handleNum) {
                        item.isSelected = true;
                      } else {
                        item.isSelected = false;
                      }
                    });
                  }),
                );
                numHelpers.setValue(each.handleNum);
                durationNumHelpers.setValue(each.durationNum);
              }}
              className="px-[16px] py-[14px] leading-[20px] mr-[16px]"
            >
              {t('aiorder_renci', {
                x: each.handleNum,
              })}
            </CheckContainer>
          );
        })}
      </div>
      <div className="text-[var(--fett-text-tertiary)]">
        {t('aiorder_traffic_pkg_tip', {
          x: find(recommendTrafficPackageInfos, (e) => e.isSelected)?.durationNum,
        })}
      </div>
    </div>
  );
});

TrafficPkg.displayName = 'TrafficPkg';
